import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { updateUserData } from '../../actions/users';
import Steps from '../../components/Register/steps';
import * as UsersApi from '../../api/users';

class RegistrationSteps extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { user } = this.props;

    return <Steps user={user} />;
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  updateUserData: (data) => dispatch(updateUserData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RegistrationSteps));
